import React, { useEffect, useState } from 'react';
import VirtualizedSelect from 'react-virtualized-select';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { SelectWrapper, shapes } from '@cimpress/react-components';
const { Spinner } = shapes;
import { listTemplates } from '../apis/stereotype.api';
import { getI18nInstance } from '../i18n';
import '../styles/index.css';
export const TemplateSelect = (props) => {
    const [templates, setTemplates] = useState(props.templateList || null);
    // This allows to track if there is any change in the templateList props
    const templateListKey = JSON.stringify(props.templateList);
    // when used in conjunction with selectedTemplateOption,
    // allows for client-side populating the select upon creating a template
    // and even selecting back and forth between client-side and server-side data.
    const [pastSelectedTemplates, setPastSelectedTemplates] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [fetchingError, setFetchingError] = useState(null);
    const [lastRefreshKey, setLastRefreshKey] = useState(null);
    const [lastTemplateMetadataFilter, setLastTemplateMetadataFilter] = useState(null);
    const [lastTemplateTypeFilter, setLastTemplateTypeFilter] = useState(null);
    const t = getI18nInstance().getFixedT(props.language);
    const addToPastSelectedTemplates = (option) => {
        if (option && pastSelectedTemplates.length > 0 && !pastSelectedTemplates.some(el => el.value === option.value)) {
            setPastSelectedTemplates(pastSelectedTemplates => pastSelectedTemplates.some(el => el.value === option.value)
                ? pastSelectedTemplates
                : [...pastSelectedTemplates, option]);
        }
    };
    const refreshKey1 = JSON.stringify([props.accessToken, props.filterTemplateTypeBy, props.filterTemplateMetadataBy]);
    useEffect(() => {
        setPastSelectedTemplates([]);
    }, [refreshKey1]);
    useEffect(() => {
        setTemplates(props.templateList || null);
    }, [templateListKey]);
    const refreshKey2 = JSON.stringify([props.accessToken, props.refreshKey, props.filterTemplateTypeBy, props.filterTemplateMetadataBy]);
    useEffect(() => {
        if (!props.templateList && !fetching && (templates === null || lastRefreshKey !== props.refreshKey || lastTemplateTypeFilter !== props.filterTemplateTypeBy || lastTemplateMetadataFilter !== props.filterTemplateMetadataBy) && props.accessToken) {
            setFetching(true);
            setLastRefreshKey(props.refreshKey);
            setLastTemplateMetadataFilter(props.filterTemplateMetadataBy);
            setLastTemplateTypeFilter(props.filterTemplateTypeBy);
            listTemplates(props.accessToken, props.filterTemplateTypeBy, props.filterTemplateMetadataBy)
                .then((templates) => {
                setTemplates(templates);
                setFetching(false);
            })
                .catch((err) => {
                setTemplates(null);
                setFetching(false);
                setFetchingError(err);
                if (props.onError) {
                    props.onError(err);
                }
            });
        }
    }, [refreshKey2]);
    const handleChange = (option) => {
        if (props.onChange) {
            props.onChange(option.value);
        }
        if (props.onChangeOption) {
            props.onChangeOption(option);
        }
    };
    const getOptions = () => {
        if (!templates) {
            if (fetchingError) {
                return [{
                        label: t('error'),
                        value: '-1',
                    }];
            }
            if (fetching) {
                return [{
                        label: t('loading'),
                        value: '-1',
                    }];
            }
            return [{
                    label: t('no-data'),
                    value: '-1',
                }];
        }
        return templates
            .map((t) => ({
            label: t.templateName || t.templateId,
            value: t.links.self.href,
        }));
    };
    const options = [...getOptions(), ...pastSelectedTemplates];
    const optionsDeduplicated = options.filter((el, i) => options.findIndex(e => e.value === el.value) === i);
    const selected = props.selectedTemplateOption || options.find(a => a.value === props.selectedTemplateUrl);
    addToPastSelectedTemplates(selected);
    const hasData = !(options.length === 1 && options[0].value === '-1');
    return React.createElement(SelectWrapper, { disabled: !hasData || fetching, selectedSelect: VirtualizedSelect, label: !fetching
            ? props.label || t('template-select-label')
            : React.createElement("span", { className: 'template-select-label' },
                props.label || t('template-select-label'),
                React.createElement(Spinner, { className: "spinner", size: 'small' })), value: selected, options: optionsDeduplicated, noResultsText: t('no-results-found'), clearable: false, onChange: (option) => handleChange(option), helpText: props.helpText, containerClassName: props.containerClassName, tether: true });
};
//# sourceMappingURL=TemplateSelect.js.map